import React, { useEffect } from 'react';

export default function WholesaleMarket() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fadeIn');
        }
      });
    }, { threshold: 0.2 });

    const items = document.querySelectorAll('.wholesale-fade');
    items.forEach((item, idx) => {
      item.style.transitionDelay = `${idx * 0.15}s`;
      observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const s = {
    section: {
      padding: '8rem 6%',
      backgroundColor: '#D9B99B', // latte (warm call to action)
      color: '#1C1209', // charcoal
    },
    container: {
      maxWidth: '1240px',
      margin: '0 auto',
      display: 'grid',
      gap: '4rem',
      alignItems: 'center',
    },
    left: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    subtitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.9rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#6B3A2A', // mahogany
    },
    title: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
      lineHeight: 1.1,
    },
    body: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '1.05rem',
      lineHeight: 1.7,
      color: '#2E1503', // espresso
      maxWidth: '500px',
    },
    right: {
      backgroundColor: '#FAF7F2',
      padding: '4rem 3rem',
      borderRadius: '2px',
      boxShadow: '0 20px 40px rgba(0,0,0,0.05)',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1.5rem',
    },
    formTitle: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1.8rem',
    },
    cta: {
      display: 'inline-block',
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.85rem',
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: '#FAF7F2',
      backgroundColor: '#1C1209',
      border: 'none',
      padding: '1rem 2.5rem',
      borderRadius: '2px',
      cursor: 'pointer',
      transition: 'background 0.3s ease',
      marginTop: '1rem',
    }
  };

  return (
    <section id="wholesale" style={s.section}>
      <div className="wholesale-grid" style={s.container}>

        <div className="wholesale-fade preFade" style={s.left}>
          <div style={s.subtitle}>Partner With Us</div>
          <h2 style={s.title}>The American Market. Supplied.</h2>
          <p style={s.body}>
            Our primary ambition is supplying the massive demands of the United States.
            From bustling urban cafes to large-scale retail distributors, we offer reliable,
            high-volume shipments of strictly graded Kenyan coffee.
          </p>
          <p style={s.body}>
            When you partner with Savanna Sips, you have direct access to the source, ensuring
            transparency, competitive wholesale pricing, and a product that stands out in the
            most competitive world markets.
          </p>
        </div>

        <div className="wholesale-fade preFade" style={s.right}>
          <h3 style={s.formTitle}>Start The Conversation</h3>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: '0.9rem', color: '#4A2C1A' }}>
            Looking for bulk green beans or custom roasting for your enterprise? Let's discuss volume and logistics.
          </p>
          <a href="/contact" style={{ textDecoration: 'none' }}>
            <button
              style={s.cta}
              onMouseEnter={e => e.target.style.backgroundColor = '#A0693A'}
              onMouseLeave={e => e.target.style.backgroundColor = '#1C1209'}
            >
              Request Catalog
            </button>
          </a>
        </div>

      </div>
    </section>
  );
}
